<div class="absolute inset-0 bg-gray-200 animate-pulse"></div>
